import { Routes } from '@angular/router';
import { carInsuranceRoutes } from './car-insurance.routes';
import { AsahiRoutes } from './asahi.routes';
// import { cimbRoutes } from './cimb.routes';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'en/income-protection-insurance',
    pathMatch: 'full',
  },
  {
    path: ':lang/income-protection-insurance',
    children: AsahiRoutes
  },
  {
    path: ':lang/car-insurance',
    children: carInsuranceRoutes
  },
  // {
  //   path: ':lang/cimb',
  //   children: cimbRoutes
  // }
];
